module.exports = ".page-content {\r\n\r\n    padding: 40px;\r\n    padding-top: 150px;\r\n}\r\n\r\nul{\r\n    list-style-type: disc !important;\r\n    margin-left: 20px;\r\n}\r\n\r\nli{\r\n    list-style-type: disc !important;\r\n    /* Default is decimal */\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/terms/terms.component.css
// module id = ./src/app/terms/terms.component.css
// module chunks = main